import { Link, useLocation } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { usePageMeta } from '@/hooks/usePageMeta';

export default function NotFound() {
  const location = useLocation();
  usePageMeta('页面不存在 - 嫩草影院', '你访问的页面不存在或已被移除。');

  return (
    <div className="flex min-h-screen flex-col bg-background-950">
      <Navbar />
      <main className="flex flex-1 items-center justify-center px-4 py-20">
        <div className="flex flex-col items-center text-center">
          <p className="font-heading text-7xl font-extrabold text-primary-500/30 md:text-9xl">404</p>
          <h1 className="mt-4 font-heading text-2xl font-bold text-foreground-50">
            页面不存在
          </h1>
          <p className="mt-2 max-w-md text-sm text-foreground-400">
            你访问的页面 <span className="break-all text-foreground-200">{location.pathname}</span>{' '}
            可能已被移除或链接有误。
          </p>
          <div className="mt-6 flex flex-wrap justify-center gap-3">
            <Link
              to="/"
              className="flex h-11 items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 text-sm font-semibold text-background-950 transition-colors hover:bg-primary-400"
            >
              <i className="ri-home-4-line" />
              返回首页
            </Link>
            <Link
              to="/category?type=movie"
              className="flex h-11 items-center gap-2 whitespace-nowrap rounded-md border border-background-700 px-6 text-sm font-medium text-foreground-200 transition-colors hover:border-primary-600 hover:text-primary-400"
            >
              <i className="ri-film-line" />
              浏览影视
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}